import React, { useState, useEffect } from "react"
import styled from "@emotion/styled"
import { graphql } from "gatsby"

import { setCookie } from "../../utils/cookies"
import { meshProductDuoDataV2 } from "../../utils/productloader"
import productloader from "../../utils/productloaderv2"
import SEO from "../../components/seo"
import ATC from "../../components/influencerpage/atcareabase_inf"
import ATCAreaNoDefault from "../../components/influencerpage/atcareanodefault"
import ClinicalProof from "../../components/wild/master/promo/clinicalproof"
import FaqArea from "../../components/wild/master/promo/faq"
import Editorial from "../../components/wild/master/fb/editorial"
import ModalWildAlt from "../../components/wild/master/modalwildalt"
import ListIngredients from "../../components/wild/master/ingredients/listingredients"
import ProductOptionsSchema from "../../components/wild/global/productoptionsschema"

import { data as dataDefault } from "../../data/lp/influencer"
import { ingredients_fb } from "../../data/data_promo_ingredients"

const Wrapper = styled.div`
  .WrapperEditorial {
    margin: 0 0 64px;
    padding: 0 16px;
    max-width: 1600px;
    @media (min-width: 768px) {
      margin: 40px auto;
      padding: 0 40px;
    }
    @media (min-width: 1024px) {
      margin: 64px auto;
      padding: 0 56px;
    }
  }
`

/**
 **
 * https://nutrafol.atlassian.net/browse/NT2-17688
 *For ex:
 *http://nutrafol.com/influencer/wom/amy - This would pre-select women’s core and the promo code name would be amy.
 *
 *http://nutrafol.com/influencer/veg/amy
 *http://nutrafol.com/influencer/pos/amy
 *http://nutrafol.com/influencer/bal/amy
 *http://nutrafol.com/influencer/men/john
 *
 **
 */

const prodMap = {
  wom: "Women",
  veg: "Vegan",
  bal: "Balance",
  pos: "Postpartum",
  men: "Men",
  none: "None",
}

export const query = graphql`
  query PartnerQuery {
    magento {
      products(
        filter: {
          sku: {
            in: [
              "WOM1"
              "WOM3"
              "WOM3PROMO"
              "WOM6"
              "VEG1"
              "VEG3"
              "VEG3PROMO"
              "VEG6"
              "BAL1"
              "BAL3"
              "BAL3PROMO"
              "BAL6"
              "POS1"
              "POS3"
              "POS3PROMO"
              "POS6"
              "MENPRO1"
              "MENPRO3"
              "MEN3PROMO"
              "MENPRO6"
            ]
          }
        }
      ) {
        ...ProductData
      }
      ...AttributeData
    }
  }
`
const InfluencerCore = ({ data }) => {
  const { products, customAttributeMetadata } = data.magento
  const [partner, setPartner] = useState("")
  const [product, setProduct] = useState("wom")
  const [defaultProduct, setDefaultProduct] = useState(
    prodMap[product] || "Women"
  )
  const [activeProduct, setActiveProduct] = useState(defaultProduct)

  const pageSource = "influencer_lp"
  const [showIngredientModal, setShowIngredientModal] = useState(false)
  const [ingrOption, setIngrOption] = useState(0)
  const isNoDefault = defaultProduct === "None"

  productloader.getMagentoProductsWithAttributes(
    products?.items || [],
    customAttributeMetadata
  )
  meshProductDuoDataV2(products?.items, dataDefault)

  useEffect(() => {
    const path = window.location.pathname.split("/")
    const idx = path.indexOf("influencer")
    const urlProduct = path[idx + 1]
    const urlPartner = path[idx + 2]
    if (urlPartner && urlProduct) {
      setPartner(urlPartner)
      setProduct(urlProduct)
      setDefaultProduct(prodMap[urlProduct] || "Women")
      setActiveProduct(prodMap[urlProduct] || "Women")
      setCookie("influencer", urlPartner, 365, window.location.pathname)
    } else {
      console.warn(`partner value is missing`)
    }
  }, [])

  return (
    <Wrapper>
      <SEO
        title={dataDefault.seo.title}
        description={dataDefault.seo.description}
      />
      {Object.keys(dataDefault.products).map((el, i) => {
        return (
          <ProductOptionsSchema
            options={dataDefault.products[el].options}
            key={i}
          />
        )
      })}
      {isNoDefault ? (
        <ATCAreaNoDefault
          data={dataDefault}
          page_source={pageSource}
          code={partner}
          defaultProduct={defaultProduct}
          comparisonColumnsArr={dataDefault.comparisonColumnsArr}
        />
      ) : (
        <ATC
          data={dataDefault}
          page_source={pageSource}
          code={partner}
          setActiveProduct={setActiveProduct}
          activeProduct={activeProduct}
          comparisonColumnsArr={dataDefault.comparisonColumnsArr}
        />
      )}

      <Editorial
        data={ingredients_fb}
        title={`Bio-specific formulas tailored to what your body and hair needs to grow.`}
        ingrOption={ingrOption}
        setIngrOption={setIngrOption}
        onCtaClick={() => setShowIngredientModal(true)}
      />
      <ClinicalProof data={dataDefault.clinicalProof} />
      <FaqArea questions={dataDefault.questions} isWide={true} />
      {showIngredientModal ? (
        <ModalWildAlt
          component={ListIngredients}
          propsObject={{
            content: ingredients_fb[ingrOption],
          }}
          name={ingredients_fb[ingrOption].name}
          hideModal={() => setShowIngredientModal(false)}
          modalSize="small"
        />
      ) : null}
    </Wrapper>
  )
}

export default InfluencerCore
